import { useQuery } from '@tanstack/react-query';

import getTaskSummary from 'Api/host-presence-content/getTaskSummary';
import getTaskSummaryResponse from './model/response/getTaskSummaryResponse';

import { useUserInfo } from 'Store/userInfo';

const useGetTaskSummary = ({ enabled }) => {
  const { userId } = useUserInfo();
  return useQuery({
    queryKey: ['host-task-summary', userId],
    queryFn: async () => {
      const response = await getTaskSummary();

      const result = getTaskSummaryResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetTaskSummary;
